import React from "react";
import GenericModal from "components/MainApp/atoms/Modals/GenericModal";
import { Button } from "@mui/material"

import styles from "./DeleteReceptionTagsModal.module.scss";
import i18n from "i18n";
const DeleteReceptionTagsModal = ({ open, handleClose, handleCancel, handleConfirm}) => {
    const content = <div className={styles["delete-reception-tags-modal-content"]}>
        <div className={styles["title"]}>{i18n.t("remove.added.tags")}</div>
        <div className={styles["subtitle"]}>{i18n.t("delete.read.tags.question")}</div>
        <div className={styles["delete-reception-tags-modal-buttons"]}>
          <div
              onClick={handleCancel}
              data-automation-id="cancel"
            >
              {i18n.t("cancel").toUpperCase()}
            </div>
          <Button className={styles["btn-continue"]} onClick={handleConfirm}>{i18n.t("continue").toUpperCase()}</Button>
        </div>
    </div>
    return (
      <div className={styles["delete-reception-tags-modal-container"]}>
          <GenericModal
            open={open}
            content={content}
            handleClose={handleClose}></GenericModal>
      </div>
    );
}


export default DeleteReceptionTagsModal;